import { Fragment, useContext, useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import PageHeading from "../../Components/PageHeading/PageHeading";
import { UserAuthContext } from "../../Contexts/UserAuthContext";
import moneyExchangeIcon from "../../Assets/Images/transaction-data.png";
import { Button } from "@mui/material";
import swal from "sweetalert";
import AiFactsDisplay from "../../Components/AiFacts/AiFactsDisplay";
import "./AdVideoGenerator.css";
import { AdVideoExamplePrompt } from "./AdVideoExamplePrompt";
import axios from "axios";

const formQuestions = [
    { key: "promoting", label: "What are you promoting?", placeholder: "e.g. Smart Home Automation System", required: true },
    { key: "targetAudience", label: "Who is your target audience?", placeholder: "e.g. Busy professionals and families", required: true },
    { key: "keyMessage", label: "What is the key message?", placeholder: "e.g. Control your home with your voice", required: true },
    { key: "action", label: "What action should viewers take?", placeholder: "e.g. Visit our website for a free demo", required: true },
    { key: "visualStyle", label: "What visual style do you want?", placeholder: "e.g. Futuristic and cozy", required: true },
    { key: "specialInstructions", label: "Any special instructions?", placeholder: "e.g. Focus on family interactions", required: false, isTextarea: true },
];

const initialFormState = {
    promoting: "",
    targetAudience: "",
    keyMessage: "",
    action: "",
    visualStyle: "",
    specialInstructions: "",
};

// Helper: format snake_case or camelCase keys to Title Case
const formatKey = (key) =>
    key
        .replace(/_/g, " ")
        .replace(/([A-Z])/g, " $1")
        .replace(/^\w/, (c) => c.toUpperCase())
        .trim();

// ===== Sub-components =====

function GenerateBibleButton({ label, onClick, loading = false }) {
    return (
        <button
            type="button"
            onClick={onClick}
            disabled={loading}
            style={{
                border: "none",
                borderRadius: "5px",
                padding: "7px 14px",
                background: "linear-gradient(135deg, #0d5b8f, #073b5c)",
                color: "#fff",
                fontSize: "13px",
                fontWeight: "500",
                lineHeight: "1.2",
                cursor: loading ? "not-allowed" : "pointer",
                opacity: loading ? 0.65 : 1,
                boxShadow: "0 3px 8px rgba(0, 0, 0, 0.2)",
                transition: "all 0.2s ease",
                whiteSpace: "nowrap",
            }}
        >
            {loading ? "Generating..." : label}
        </button>
    );
}

function CharacterBible({ characters }) {
    if (!characters) return null;

    // Normalize: support both array format (Claude) and object format (GPT)
    const charList = Array.isArray(characters)
        ? characters
        : Object.entries(characters).map(([key, char]) => ({ ...char, _key: key }));

    if (charList.length === 0) return null;

    return (
        <div className="advideo-section-card">
            {/* <div className="advideo-section-title">Character Bible ?</div> */}
            <div
                className="advideo-section-title"
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: "12px",
                }}
            >
                <span>Character Bible</span>

                <GenerateBibleButton
                    label="Generate Character"
                    onClick={handleGenerateCharacter}
                />
            </div>
            <div className="advideo-horizontal-slider">
                {charList.map((char, idx) => {
                    const name = char.character_name || char.name || char._key || `Character ${idx + 1}`;
                    return (
                        <div key={char._key || idx} className="advideo-character-card">
                            <div className="advideo-character-name">
                                <span className="char-icon">
                                    {name.charAt(0).toUpperCase()}
                                </span>
                                {name}
                            </div>
                            {Object.entries(char)
                                .filter(([k]) => !["character_name", "name", "_key"].includes(k))
                                .map(([k, v]) => (
                                    <div key={k} className="advideo-character-detail">
                                        <span className="detail-label">{formatKey(k)}:</span>
                                        <span className="detail-value">{typeof v === 'object' ? JSON.stringify(v) : v}</span>
                                    </div>
                                ))}
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

function handleGenerateCharacter() {
    console.log("Generate Character clicked");

    swal({
        title: "Coming Soon",
        text: "Character generation is not available yet. This feature will be implemented very soon.",
        icon: "info",
        button: "Okay",
        className: "modal_class_success",
    });

    // TODO:
    // API call will be added here later
}

function LocationBible({ locations }) {
    if (!locations) return null;

    // Support both array format (Claude) and object format (GPT)
    if (Array.isArray(locations)) {
        if (locations.length === 0) return null;
        return (
            <div className="advideo-section-card">
                {/* <div className="advideo-section-title">Location Bible</div> */}
                <div
                    className="advideo-section-title"
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: "12px",
                    }}
                >
                    <span>Location Bible</span>

                    <GenerateBibleButton
                        label="Generate Location"
                        onClick={handleGenerateLocation}
                    />
                </div>
                <div className="advideo-horizontal-slider">
                    {locations.map((loc, idx) => {
                        const name = loc.location_name || loc.name || `Location ${idx + 1}`;
                        const locType = loc.type || loc.location_type;
                        return (
                            <div key={idx} className="advideo-location-card">
                                <div className="advideo-location-name">
                                    {name}
                                    {/* {locType && (
                                        <span
                                            className="loc-badge"
                                            style={
                                                locType.toLowerCase() === "primary"
                                                    ? {}
                                                    : { background: "linear-gradient(135deg, #6c757d, #adb5bd)" }
                                            }
                                        >
                                            {locType}
                                        </span>
                                    )} */}

                                    {locType && (
                                        <span
                                            className="loc-badge"
                                            style={{
                                                // display: "inline-flex",
                                                alignItems: "center",
                                                gap: "6px",
                                                marginLeft: "0px",
                                                padding: "5px 10px",
                                                borderRadius: "6px",
                                                fontSize: "10px",
                                                fontWeight: "600",
                                                letterSpacing: "0.5px",
                                                lineHeight: "1",
                                                textTransform: "uppercase",
                                                // whiteSpace: "nowrap",

                                                color:
                                                    locType.toLowerCase() === "primary"
                                                        ? "#67e8f9"
                                                        : "#c4b5fd",

                                                background:
                                                    locType.toLowerCase() === "primary"
                                                        ? "rgba(34, 211, 238, 0.10)"
                                                        : "rgba(139, 92, 246, 0.10)",

                                                border:
                                                    locType.toLowerCase() === "primary"
                                                        ? "1px solid rgba(34, 211, 238, 0.25)"
                                                        : "1px solid rgba(139, 92, 246, 0.25)",

                                                boxShadow:
                                                    locType.toLowerCase() === "primary"
                                                        ? "0 0 12px rgba(34, 211, 238, 0.08)"
                                                        : "0 0 12px rgba(139, 92, 246, 0.08)",
                                            }}
                                        >
                                            <span
                                                style={{
                                                    width: "6px",
                                                    height: "6px",
                                                    borderRadius: "50%",
                                                    flexShrink: 0,
                                                    background:
                                                        locType.toLowerCase() === "primary"
                                                            ? "#22d3ee"
                                                            : "#8b5cf6",
                                                    boxShadow:
                                                        locType.toLowerCase() === "primary"
                                                            ? "0 0 6px rgba(34, 211, 238, 0.7)"
                                                            : "0 0 6px rgba(139, 92, 246, 0.7)",
                                                }}
                                            />

                                            {locType}
                                        </span>
                                    )}
                                </div>
                                {Object.entries(loc)
                                    .filter(([k]) => !["location_name", "name", "type", "location_type"].includes(k))
                                    .map(([k, v]) => (
                                        <div key={k} className="advideo-location-detail">
                                            <span className="detail-label">{formatKey(k)}:</span>
                                            <span className="detail-value">{typeof v === 'object' ? JSON.stringify(v) : v}</span>
                                        </div>
                                    ))}
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }

    // Object format (GPT with primary_locations / supporting_locations)
    const primary = locations.primary_locations || {};
    const supporting = locations.supporting_locations || {};

    if (Object.keys(primary).length === 0 && Object.keys(supporting).length === 0) return null;

    return (
        <div className="advideo-section-card">
            <div className="advideo-section-title">Location Bible</div>
            <div className="advideo-horizontal-slider">
                {Object.keys(primary).length > 0 && (
                    <>
                        {Object.entries(primary).map(([key, loc]) => (
                            <div key={key} className="advideo-location-card">
                                <div className="advideo-location-name">
                                    {formatKey(key)}
                                    <span className="loc-badge">Primary</span>
                                </div>
                                {Object.entries(loc).map(([k, v]) => (
                                    <div key={k} className="advideo-location-detail">
                                        <span className="detail-label">{formatKey(k)}:</span>
                                        <span className="detail-value">{typeof v === 'object' ? JSON.stringify(v) : v}</span>
                                    </div>
                                ))}
                            </div>
                        ))}
                    </>
                )}

                {Object.keys(supporting).length > 0 && (
                    <>
                        {Object.entries(supporting).map(([key, loc]) => (
                            <div key={key} className="advideo-location-card">
                                <div className="advideo-location-name">
                                    {formatKey(key)}
                                    <span className="loc-badge" style={{ background: "linear-gradient(135deg, #6c757d, #adb5bd)" }}>Supporting</span>
                                </div>
                                {Object.entries(loc).map(([k, v]) => (
                                    <div key={k} className="advideo-location-detail">
                                        <span className="detail-label">{formatKey(k)}:</span>
                                        <span className="detail-value">{typeof v === 'object' ? JSON.stringify(v) : v}</span>
                                    </div>
                                ))}
                            </div>
                        ))}
                    </>
                )}
            </div>
        </div>
    );
}

function handleGenerateLocation() {
    console.log("Generate Location clicked");

    swal({
        title: "Coming Soon",
        text: "Location generation is not available yet. This feature will be implemented very soon.",
        icon: "info",
        button: "Okay",
        className: "modal_class_success",
    });

    // TODO:
    // API call will be added here later
}

function StoryStructure({ story }) {
    if (!story) return null;

    return (
        <div className="advideo-section-card">
            <div className="advideo-section-title">Story Structure</div>
            <table className="advideo-story-table">
                <thead>
                    <tr>
                        <th>Element</th>
                        <th>Description</th>
                    </tr>
                </thead>
                <tbody>
                    {Object.entries(story).map(([key, value]) => (
                        <tr key={key}>
                            <td>{formatKey(key)}</td>
                            <td>{value}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

function SceneCard({ scene, onCopy, onEdit }) {
    const [editing, setEditing] = useState(false);
    const [editData, setEditData] = useState({});

    const handleStartEdit = () => {
        setEditData({ ...scene });
        setEditing(true);
        if (onEdit) onEdit(scene.scene_number, "start");
    };

    const handleCancelEdit = () => {
        setEditing(false);
        setEditData({});
    };

    const handleSaveEdit = () => {
        // For now just exit edit mode. API integration later.
        setEditing(false);
        if (onEdit) onEdit(scene.scene_number, "save", editData);
    };

    // Determine which fields to display (exclude scene_number and scene_title as they're in header)
    const displayFields = Object.entries(scene).filter(
        ([k]) => !["scene_number", "scene_title"].includes(k)
    );

    const copySceneText = () => {
        const text = displayFields
            .map(([k, v]) => `${formatKey(k)}: ${v}`)
            .join("\n\n");
        const header = `Scene ${scene.scene_number} — ${scene.scene_title}\n\n`;
        onCopy(header + text);
    };

    return (
        <div className="advideo-scene-card">
            <div className="advideo-scene-header">
                <div className="advideo-scene-header-left">
                    <div className="advideo-scene-number">{scene.scene_number}</div>
                    <div>
                        <div className="advideo-scene-title">{scene.scene_title}</div>
                        {scene.duration_seconds && (
                            <div className="advideo-scene-duration">{scene.duration_seconds}s</div>
                        )}
                    </div>
                </div>
                <div className="advideo-scene-actions">
                    <button className="advideo-scene-btn copy-btn" onClick={copySceneText}>
                        <span className="btn-icon">📋</span> Copy
                    </button>
                    <button className="advideo-scene-btn edit-btn" onClick={editing ? handleCancelEdit : handleStartEdit}>
                        <span className="btn-icon">{editing ? "✕" : "✏️"}</span> {editing ? "Cancel" : "Edit"}
                    </button>
                </div>
            </div>
            <div className="advideo-scene-body">
                {displayFields.map(([key, value]) => (
                    <div key={key} className="advideo-scene-field">
                        <div className="advideo-scene-field-label">{formatKey(key)}</div>
                        {editing ? (
                            <textarea
                                className="advideo-scene-edit-textarea"
                                value={editData[key] || ""}
                                onChange={(e) =>
                                    setEditData((prev) => ({ ...prev, [key]: e.target.value }))
                                }
                            />
                        ) : (
                            <div className="advideo-scene-field-value">{value}</div>
                        )}
                    </div>
                ))}
                {editing && (
                    <div className="advideo-scene-edit-actions">
                        <button className="advideo-scene-cancel-btn" onClick={handleCancelEdit}>
                            Cancel
                        </button>
                        <button className="advideo-scene-save-btn" onClick={handleSaveEdit}>
                            Save Changes
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
}

// ===== Main Component =====

export default function AdVideoGenerator() {
    const [formData, setFormData] = useState(initialFormState);
    const [isLoading, setIsLoading] = useState(false);
    const [resultData, setResultData] = useState(null);
    const [activeTab, setActiveTab] = useState("scenes"); // "characters" | "locations" | "story" | "scenes" | "prompts"
    const [copiedToast, setCopiedToast] = useState(false);
    const [suggestedPrompt, setSuggestedPrompt] = useState("");
    const [backendSuggestions, setBackendSuggestions] = useState(null);
    const [checkingPrompt, setCheckingPrompt] = useState(false);
    const promptTimeoutRef = useRef(null);

    useEffect(() => {
        setSuggestedPrompt(AdVideoExamplePrompt[Math.floor(Math.random() * AdVideoExamplePrompt.length)]);

        const intervalId = setInterval(() => {
            setSuggestedPrompt(AdVideoExamplePrompt[Math.floor(Math.random() * AdVideoExamplePrompt.length)]);
        }, 5000);

        return () => clearInterval(intervalId);
    }, []);

    const { AIuser } = useContext(UserAuthContext);
    const navigate = useNavigate();

    const creditToLocalString = AIuser?.credits
        ? parseInt(Math.floor(AIuser?.credits)).toLocaleString()
        : "0";

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const handleInputChange = (key, value) => {
        setFormData((prev) => ({ ...prev, [key]: value }));
    };

    const checkPromotingPrompt = async (value) => {
        if (!value?.trim()) {
            setBackendSuggestions(null);
            return;
        }

        try {
            setCheckingPrompt(true);

            const authToken = localStorage.getItem("aiUser");

            const res = await axios.post(
                "https://backend.whalesai.com/api/v1/prompt-checker/check",
                {
                    prompt: value,
                    aiService: "ad-video-ai",
                },
                {
                    headers: {
                        authorization: `Bearer ${authToken}`,
                    },
                }
            );

            if (res?.data?.success) {
                setBackendSuggestions(res.data.data.suggested_prompt);
            }
        } catch (error) {
            console.log("Prompt checker error:", error);
        } finally {
            setCheckingPrompt(false);
        }
    };

    const isFormValid =
        formData.promoting.trim() &&
        formData.targetAudience.trim() &&
        formData.keyMessage.trim() &&
        formData.action.trim() &&
        formData.visualStyle.trim();

    const handleClear = () => {
        setFormData(initialFormState);
        setResultData(null);
        setActiveTab("scenes");
        setBackendSuggestions(null);
    };

    const handleGenerate = async () => {
        if (!isFormValid) {
            swal({
                text: "Please fill in all required fields.",
                icon: "warning",
                buttons: "Ok",
                className: "modal_class_success",
            });
            return;
        }

        setIsLoading(true);
        setResultData(null);

        try {
            const response = await fetch(
                "https://backend.whalesai.com/api/v1/advertisement-video-ai/generate",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        authorization: `Bearer ${localStorage.getItem("aiUser")}`,
                    },
                    body: JSON.stringify({
                        promoting: formData.promoting,
                        targetAudience: formData.targetAudience,
                        keyMessage: formData.keyMessage,
                        action: formData.action,
                        visualStyle: formData.visualStyle,
                        specialInstructions: formData.specialInstructions,
                    }),
                }
            );

            const result = await response.json();

            if (!response.ok || !result.success) {
                throw new Error(result.message || "Failed to generate advertisement script.");
            }

            setResultData(result.data);
            setActiveTab("characters");
        } catch (error) {
            console.error("Error generating ad script:", error);
            swal({
                text: error.message || "Something went wrong! Please try again.",
                icon: "error",
                buttons: "Ok",
                className: "modal_class_success",
            });
        } finally {
            setIsLoading(false);
        }
    };

    const handleCopy = (text) => {
        navigator.clipboard.writeText(text).then(() => {
            setCopiedToast(true);
            setTimeout(() => setCopiedToast(false), 2000);
        });
    };

    const handleSceneEdit = (sceneNumber, action, data) => {
        // Placeholder for future API-based edit
        console.log(`Scene ${sceneNumber} edit ${action}:`, data);
    };

    const claudeData = resultData?.claudePrompt;
    const gptData = resultData?.gptPrompt;

    return (
        <Fragment>
            <PageHeading
                title={"AD VIDEO AI"}
                description={
                    "Turn your ideas into professional advertisement videos up to 60 seconds long by answering a few simple questions."
                }
            />

            <div
                className="container pb-5"
                style={{
                    maxWidth: "872px",
                    paddingInline: "12px",
                    marginInline: "auto",
                }}
            >
                <div className="container py-5">
                    {/* Credits section */}
                    <div className="d-flex align-items-center justify-content-center centralize-credits-btn-sm mt-2">
                        <div>
                            <div>
                                <button className="credits-button">
                                    CREDITS : {creditToLocalString}
                                </button>
                                <button
                                    className="buy-credits-button"
                                    onClick={() => navigate("/purchase")}
                                >
                                    BUY CREDITS
                                </button>
                                <button
                                    onClick={() => navigate("/usage")}
                                    className="money-exchange-button"
                                >
                                    <img src={moneyExchangeIcon} alt="usage" />
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Form Section */}
                    <div className="advideo-form-section">
                        {formQuestions.map((q, idx) => (
                            <div key={q.key} className="advideo-form-group">
                                <div className="advideo-step-label">Step {idx + 1}</div>
                                {/* <label className="advideo-form-label">
                                    {q.label}
                                    {q.required ? (
                                        <span className="text-danger"> *</span>
                                    ) : (
                                        <span className="optional-tag">(Optional)</span>
                                    )}
                                </label> */}
                                <div className="d-flex align-items-center justify-content-between mb-2">
                                    <label className="advideo-form-label mb-0">
                                        {q.label}
                                        {q.required ? (
                                            <span className="text-danger"> *</span>
                                        ) : (
                                            <span className="optional-tag">(Optional)</span>
                                        )}
                                    </label>

                                    {idx === 0 && (
                                        <button
                                            type="button"
                                            onClick={handleClear}
                                            disabled={
                                                (!formData.promoting &&
                                                    !formData.targetAudience &&
                                                    !formData.keyMessage &&
                                                    !formData.action &&
                                                    !formData.visualStyle &&
                                                    !formData.specialInstructions &&
                                                    !resultData) ||
                                                isLoading
                                            }
                                            style={{
                                                border: "none",
                                                background: "transparent",
                                                padding: 0,
                                                margin: 0,
                                                color: "#fff",
                                                fontSize: "13px",
                                                fontWeight: "500",
                                                textDecoration: "underline",
                                                textUnderlineOffset: "3px",
                                                cursor: isLoading ? "not-allowed" : "pointer",
                                                opacity: isLoading ? 0.5 : 1,
                                            }}
                                        >
                                            Clear All
                                        </button>
                                    )}
                                </div>
                                {q.isTextarea ? (
                                    <textarea
                                        className="advideo-textarea"
                                        placeholder={q.placeholder}
                                        value={formData[q.key]}
                                        onChange={(e) => handleInputChange(q.key, e.target.value)}
                                        disabled={isLoading}
                                    />
                                ) : (
                                    <input
                                        type="text"
                                        className="advideo-input"
                                        placeholder={q.placeholder}
                                        value={formData[q.key]}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            handleInputChange(q.key, value);

                                            if (q.key === "promoting") {
                                                if (promptTimeoutRef.current) {
                                                    clearTimeout(promptTimeoutRef.current);
                                                }
                                                promptTimeoutRef.current = setTimeout(() => {
                                                    checkPromotingPrompt(value);
                                                }, 1500);
                                            }
                                        }}
                                        disabled={isLoading}
                                    />
                                )}
                                {q.key === "promoting" && (
                                    <>
                                        {checkingPrompt && (
                                            <div className="d-flex align-items-center mt-3 mb-2">
                                                <div className="spinner-border text-light spinner-border-sm me-2" role="status">
                                                    <span className="visually-hidden">Loading...</span>
                                                </div>
                                                <span className="text-warning" style={{ marginLeft: "8px" }}>Generating suggestions...</span>
                                            </div>
                                        )}

                                        <div className="mt-2" style={{ fontSize: "13px", color: "#a0a0a0" }}>
                                            Suggested:{" "}
                                            <span
                                                style={{ color: "#4da8da", cursor: "pointer", textDecoration: "underline" }}
                                                onClick={() => {
                                                    handleInputChange("promoting", suggestedPrompt);
                                                    if (promptTimeoutRef.current) {
                                                        clearTimeout(promptTimeoutRef.current);
                                                    }
                                                    checkPromotingPrompt(suggestedPrompt);
                                                }}
                                            >
                                                {suggestedPrompt}
                                            </span>
                                        </div>
                                    </>
                                )}

                                {backendSuggestions && backendSuggestions[q.key] && (
                                    <div
                                        onClick={() => handleInputChange(q.key, backendSuggestions[q.key])}
                                        style={{
                                            cursor: "pointer",
                                            background: "#0b2d4d",
                                            padding: "12px",
                                            borderRadius: "10px",
                                            marginTop: "12px",
                                            marginBottom: "12px",
                                            border: "1px solid #fff",
                                        }}
                                    >
                                        <p className="mb-1 text-warning" style={{ fontSize: "14px" }}>Suggested Idea:</p>
                                        <p className="mb-0 text-white" style={{ fontSize: "14px" }}>{backendSuggestions[q.key]}</p>
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>

                    {/* Action Buttons */}
                    <div className="d-flex justify-content-center align-items-center mb-5">
                        <Button
                            sx={{
                                padding: "8px 30px",
                                marginRight: "10px",
                                color: "#000",
                                background: "#fff",
                                "&:hover": { background: "#fff" },
                                "&:disabled": { background: "#fff" },
                            }}
                            onClick={handleClear}
                            disabled={
                                (!formData.promoting &&
                                    !formData.targetAudience &&
                                    !formData.keyMessage &&
                                    !formData.action &&
                                    !formData.visualStyle &&
                                    !formData.specialInstructions &&
                                    !resultData) ||
                                isLoading
                            }
                            variant="contained"
                        >
                            Clear
                        </Button>
                        <Button
                            sx={{
                                padding: "8px 30px",
                                "&:disabled": { background: "gray" },
                            }}
                            onClick={handleGenerate}
                            className="generate-button text-white"
                            disabled={!isFormValid || isLoading}
                            variant="contained"
                        >
                            {isLoading ? "Generating..." : "GENERATE PROMPTS"}
                        </Button>
                    </div>

                    <div className="animate text-md-center text-lg-center text-center mb-5 d-flex justify-content-center force-small-font">
                        Please do not navigate away from the browser.
                        <br /> Doing so will stop the process.
                    </div>
                    <div className="text-md-center text-white text-lg-center text-center d-flex justify-content-center force-small-font mt-1">
                        While AI strives for accuracy, it may occasionally make mistakes. <br />Please verify any important information.
                    </div>

                    {/* Loading */}
                    {isLoading && <AiFactsDisplay />}
                    <div className="d-flex justify-content-center mt-3">
                        {isLoading && (
                            <div
                                className="spinner-border text-light"
                                role="status"
                                style={{ width: "4rem", height: "4rem" }}
                            >
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        )}
                    </div>

                    {/* ===== Results ===== */}
                    {resultData && claudeData && (
                        <div className="advideo-result-container">
                            <div className="advideo-result-title">
                                {claudeData.video_title || "Generated Script"}
                            </div>
                            {claudeData.total_duration_seconds && (
                                <div className="advideo-result-subtitle">
                                    Total Duration: {claudeData.total_duration_seconds}s
                                </div>
                            )}

                            {/* Content Tabs */}
                            <div className="advideo-tabs">
                                {(claudeData.characters || claudeData.character_bible) && (
                                    <button
                                        className={`advideo-tab ${activeTab === "characters" ? "active" : ""}`}
                                        onClick={() => setActiveTab("characters")}
                                    >
                                        Character Bible
                                    </button>
                                )}
                                {(claudeData.locations || claudeData.location_bible) && (
                                    <button
                                        className={`advideo-tab ${activeTab === "locations" ? "active" : ""}`}
                                        onClick={() => setActiveTab("locations")}
                                    >
                                        Location Bible
                                    </button>
                                )}
                                {claudeData.story_structure && (
                                    <button
                                        className={`advideo-tab ${activeTab === "story" ? "active" : ""}`}
                                        onClick={() => setActiveTab("story")}
                                    >
                                        Story Structure
                                    </button>
                                )}
                                {claudeData.scenes && (
                                    <button
                                        className={`advideo-tab ${activeTab === "scenes" ? "active" : ""}`}
                                        onClick={() => setActiveTab("scenes")}
                                    >
                                        Scene Breakdown
                                    </button>
                                )}
                                {gptData?.scenes && (
                                    <button
                                        className={`advideo-tab ${activeTab === "prompts" ? "active" : ""}`}
                                        onClick={() => setActiveTab("prompts")}
                                    >
                                        Production Prompts
                                    </button>
                                )}
                            </div>

                            {/* Tab Content */}
                            {activeTab === "characters" && (
                                <CharacterBible characters={claudeData.characters || claudeData.character_bible} />
                            )}

                            {activeTab === "locations" && (
                                <LocationBible locations={claudeData.locations || claudeData.location_bible} />
                            )}

                            {activeTab === "story" && (
                                <StoryStructure story={claudeData.story_structure} />
                            )}

                            {activeTab === "scenes" &&
                                claudeData.scenes && (
                                    <div className="advideo-horizontal-slider">
                                        {claudeData.scenes.map((scene) => {
                                            // Extract only required fields for Scene Breakdown
                                            const filteredScene = {
                                                scene_number: scene.scene_number,
                                                scene_title: scene.scene_title,
                                                duration_seconds: scene.duration_seconds,
                                                character_actions: scene.character_actions,
                                            };
                                            return (
                                                <SceneCard
                                                    key={`breakdown-${scene.scene_number}`}
                                                    scene={filteredScene}
                                                    onCopy={handleCopy}
                                                    onEdit={handleSceneEdit}
                                                />
                                            );
                                        })}
                                    </div>
                                )}

                            {activeTab === "prompts" &&
                                gptData?.scenes && (
                                    <div className="advideo-horizontal-slider">
                                        {gptData.scenes.map((scene) => {
                                            // Extract only required fields for Production Prompts
                                            const filteredScene = {
                                                scene_number: scene.scene_number,
                                                scene_title: scene.scene_title,
                                                duration_seconds: scene.duration_seconds,
                                                video_prompt: scene.video_prompt,
                                            };
                                            return (
                                                <SceneCard
                                                    key={`prompt-${scene.scene_number}`}
                                                    scene={filteredScene}
                                                    onCopy={handleCopy}
                                                    onEdit={handleSceneEdit}
                                                />
                                            );
                                        })}
                                    </div>
                                )}
                        </div>
                    )}

                    {/* Copied Toast */}
                    {copiedToast && (
                        <div className="advideo-copied-toast">✓ Copied to clipboard</div>
                    )}
                </div>
            </div>
        </Fragment>
    );
}